import { PhotoAndTextCardFieldsFragment } from 'types/generated';
import Button, { variantFromString } from 'components/src/button';
import { getOr } from '@/utils/options';
import typewriter, { Placement, Title } from '@/analytics/segment';
import { isDoBusinessWithUsFormAtom } from '@/store';
import { useSetAtom } from 'jotai';

type Props = {
  data: PhotoAndTextCardFieldsFragment;
};

const ButtonSection = ({ data }: Props) => {
  // const dispatch = useDispatch();
  const setIsDoBusinessWithUsOpenForm = useSetAtom(isDoBusinessWithUsFormAtom);

  if (!data.buttonsCollection?.items) {
    return;
  }

  return (
    <div className="mt-24 grid gap-8 lg:mt-48 lg:flex">
      {data.buttonsCollection.items.map((button, index) => {
        if (button?.uri) {
          return (
            <a key={index} href={getOr(button?.uri, '/')}>
              <Button
                label={getOr(button?.label, '')}
                labelClasses="!font-medium"
                variant={variantFromString(button?.variant)}
                classes={`w-full`}
              />
            </a>
          );
        }
        // If no link is provided, open the "Komdu í viðskipti" form
        return (
          <Button
            label={getOr(button?.label, '')}
            variant={variantFromString(button?.variant)}
            key={index}
            onClick={() => {
              typewriter.doBusinessWithUsButtonClicked({
                placement: Placement.PhotoAndTextCard,
                title: Title.KomduÍViðskipti,
              });
              setIsDoBusinessWithUsOpenForm(true);
            }}
          />
        );
      })}
    </div>
  );
};
export default ButtonSection;
